import React from 'react';

export default class AsyncAuthModal extends React.Component {
  state = { Component: null };

  componentDidMount() {
    this._mounted = true;
    import('./modal').then(module => {
      if (this._mounted) {
        this.setState({ Component: module.default });
      }
    });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { Component } = this.state;
    return Component ? <Component /> : null;
  }
}
